"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDescriptiveDeviceCode = exports.writeUTOCSector = exports.readUTOCSector = exports.patch = exports.writeOfAnyLength = exports.cleanWrite = exports.cleanRead = exports.display = void 0;
var utils_1 = require("../utils");
var netmd_factory_interface_1 = require("./netmd-factory-interface");
var query_utils_1 = require("../query-utils");
function display(factoryInterface, text, blink) {
    if (blink === void 0) { blink = false; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, factoryInterface.setDisplayMode(netmd_factory_interface_1.DisplayMode.OVERRIDE)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, factoryInterface.setDisplayOverride(text, blink)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.display = display;
function cleanRead(factoryInterface, address, length, type, encrypted, autoDecrypt) {
    if (encrypted === void 0) { encrypted = false; }
    if (autoDecrypt === void 0) { autoDecrypt = true; }
    return __awaiter(this, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, factoryInterface.changeMemoryState(address, length, type, netmd_factory_interface_1.MemoryOpenType.READ, encrypted)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, factoryInterface.read(address, length, type)];
                case 2:
                    resp = _a.sent();
                    return [4 /*yield*/, factoryInterface.changeMemoryState(address, length, type, netmd_factory_interface_1.MemoryOpenType.CLOSE, encrypted)];
                case 3:
                    _a.sent();
                    if (encrypted && autoDecrypt) {
                        resp = utils_1.decryptDataFromFactoryTransfer(resp);
                    }
                    return [2 /*return*/, resp];
            }
        });
    });
}
exports.cleanRead = cleanRead;
function cleanWrite(factoryInterface, address, data, type, encrypted, autoEncrypt) {
    if (encrypted === void 0) { encrypted = false; }
    if (autoEncrypt === void 0) { autoEncrypt = true; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (encrypted && autoEncrypt) {
                        data = utils_1.encryptDataForFactoryTransfer(data);
                    }
                    return [4 /*yield*/, factoryInterface.changeMemoryState(address, data.length, type, netmd_factory_interface_1.MemoryOpenType.WRITE, encrypted)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, factoryInterface.write(address, data, type)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, factoryInterface.changeMemoryState(address, data.length, type, netmd_factory_interface_1.MemoryOpenType.CLOSE, encrypted)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.cleanWrite = cleanWrite;
function writeOfAnyLength(factoryInterface, address, data, type, encrypted) {
    if (encrypted === void 0) { encrypted = false; }
    return __awaiter(this, void 0, void 0, function () {
        var SIZE, arr, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    SIZE = 0x10;
                    arr = __spread(data);
                    i = 0;
                    _a.label = 1;
                case 1: return [4 /*yield*/, cleanWrite(factoryInterface, address + i++ * SIZE, new Uint8Array(arr.splice(0, SIZE)), type, encrypted)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    if (arr.length > 0) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.writeOfAnyLength = writeOfAnyLength;
function patch(factoryInterface, address, value, patchNumber, totalPatches) {
    return __awaiter(this, void 0, void 0, function () {
        var base, control, patchControl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Original method written by Sir68k.
                    utils_1.assert(value.length === 4);
                    base = 0x03802000 + patchNumber * 0x10;
                    control = 0x03802000 + totalPatches * 0x10;
                    // Write 5, 12 to main control
                    return [4 /*yield*/, cleanWrite(factoryInterface, control, new Uint8Array([5]), netmd_factory_interface_1.MemoryType.MAPPED)];
                case 1:
                    // Write 5, 12 to main control
                    _a.sent();
                    return [4 /*yield*/, cleanWrite(factoryInterface, control, new Uint8Array([12]), netmd_factory_interface_1.MemoryType.MAPPED)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, cleanRead(factoryInterface, base, 4, netmd_factory_interface_1.MemoryType.MAPPED)];
                case 3:
                    patchControl = _a.sent();
                    patchControl[0] = (patchControl[0] & 0xfe) >>> 0;
                    return [4 /*yield*/, cleanWrite(factoryInterface, base, patchControl, netmd_factory_interface_1.MemoryType.MAPPED)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, cleanRead(factoryInterface, base, 4, netmd_factory_interface_1.MemoryType.MAPPED)];
                case 5:
                    // AND 0xFD with patch control
                    patchControl = _a.sent();
                    patchControl[0] = (patchControl[0] & 0xfd) >>> 0;
                    return [4 /*yield*/, cleanWrite(factoryInterface, base, patchControl, netmd_factory_interface_1.MemoryType.MAPPED)];
                case 6:
                    _a.sent();
                    // Write patch ADDRESS
                    return [4 /*yield*/, cleanWrite(factoryInterface, base + 4, new Uint8Array(query_utils_1.formatQuery('%<d', address)), netmd_factory_interface_1.MemoryType.MAPPED)];
                case 7:
                    // Write patch ADDRESS
                    _a.sent();
                    // Write patch VALUE
                    return [4 /*yield*/, cleanWrite(factoryInterface, base + 8, value, netmd_factory_interface_1.MemoryType.MAPPED)];
                case 8:
                    // Write patch VALUE
                    _a.sent();
                    return [4 /*yield*/, cleanRead(factoryInterface, base, 4, netmd_factory_interface_1.MemoryType.MAPPED)];
                case 9:
                    // OR 1 with patch control
                    patchControl = _a.sent();
                    patchControl[0] = (patchControl[0] | 1) >>> 0;
                    return [4 /*yield*/, cleanWrite(factoryInterface, base, patchControl, netmd_factory_interface_1.MemoryType.MAPPED)];
                case 10:
                    _a.sent();
                    // write 5, 9 to main control
                    return [4 /*yield*/, cleanWrite(factoryInterface, control, new Uint8Array([5]), netmd_factory_interface_1.MemoryType.MAPPED)];
                case 11:
                    // write 5, 9 to main control
                    _a.sent();
                    return [4 /*yield*/, cleanWrite(factoryInterface, control, new Uint8Array([9]), netmd_factory_interface_1.MemoryType.MAPPED)];
                case 12:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.patch = patch;
function readUTOCSector(factoryInterface, sector) {
    return __awaiter(this, void 0, void 0, function () {
        var SIZE, parts, i, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    SIZE = 0x10;
                    parts = [];
                    i = 0;
                    _c.label = 1;
                case 1:
                    if (!(i < 147)) return [3 /*break*/, 4];
                    // 147 * 16 = 2352 - sector length
                    _b = (_a = parts).push;
                    return [4 /*yield*/, factoryInterface.readMetadataPeripheral(sector, i * SIZE, SIZE)];
                case 2:
                    // 147 * 16 = 2352 - sector length
                    _b.apply(_a, [_c.sent()]);
                    _c.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, utils_1.concatUint8Arrays.apply(void 0, __spread(parts))];
            }
        });
    });
}
exports.readUTOCSector = readUTOCSector;
function writeUTOCSector(factoryInterface, sector, data) {
    return __awaiter(this, void 0, void 0, function () {
        var SIZE, arr, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    SIZE = 0x10;
                    utils_1.assert(data.length === 2352, 'The data provided is not a valid TOC Sector');
                    arr = Array.from(data);
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!arr.length) return [3 /*break*/, 3];
                    return [4 /*yield*/, factoryInterface.writeMetadataPeripheral(sector, SIZE * i++, new Uint8Array(arr.splice(0, SIZE)))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.writeUTOCSector = writeUTOCSector;
function getDescriptiveDeviceCode(factoryInterface) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, chip, firmware, code, _b, maj, min;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, factoryInterface.getDeviceCode()];
                case 1:
                    _a = __read.apply(void 0, [_c.sent(), 2]), chip = _a[0], firmware = _a[1];
                    code = '';
                    switch (chip) {
                        case 0x20:
                            code = 'R';
                            break;
                        case 0x21:
                            code = 'S';
                            break;
                        default:
                            code = chip + "?";
                            break;
                    }
                    _b = __read(firmware.toString().split(''), 2), maj = _b[0], min = _b[1];
                    code += maj + "." + min + "00";
                    return [2 /*return*/, code];
            }
        });
    });
}
exports.getDescriptiveDeviceCode = getDescriptiveDeviceCode;
//# sourceMappingURL=netmd-factory-commands.js.map